import * as React from "react";
import { CSSProperties } from "react";
import * as PropTypes from "prop-types";
import { MuiTheme } from "material-ui/styles";
import { SvgIcon } from "material-ui/SvgIcon";
import { NonLoggedBG } from "./default/components/NonLoggedBG/LiveNonLoggedBG";

export type ThemeColor = string;

export const BlackColor = "#000000";
export const WhiteColor = "#ffffff";

export interface INavBarTheme {
  backgroundColor: ThemeColor;
  activeBackgroundColor: ThemeColor;
  color: ThemeColor;
  logo: SvgIcon;
  iconColor: ThemeColor;
  backgroundImage?: string;
}

export interface IBackOfficeTheme {
  primaryColor: ThemeColor;
  accentColor: ThemeColor;
  accent2Color: ThemeColor;
  backgroundColor: ThemeColor;
  alternateTextColor: ThemeColor;
  labelColor: ThemeColor;
  hintColor?: ThemeColor;
  raisedButtonSecondaryColor?: ThemeColor;
  raisedButtonPrimaryColor?: ThemeColor;
  logo: {
    component: SvgIcon;
    style: CSSProperties;
  };
  navBar: INavBarTheme;
  nonLogged: {
    // @TODO find better solution
    bgComponent: typeof NonLoggedBG;
    phoneComponent: React.ReactElement<any>;
    phoneScreenUrl: String;
  };
}

export interface IBackOfficeMainTheme extends MuiTheme {
  logo: SvgIcon;
  navBar: IBackOfficeNavBarTheme;
  nonLogged: any;
}

export interface IBackOfficeNavBarTheme extends MuiTheme {
  openedWidth: number;
  logo: SvgIcon;
  backgroundColor: ThemeColor;
  activeBackgroundColor: ThemeColor;
  color: ThemeColor;
  BGImage?: string;
  iconColor: ThemeColor;
}

export const ThemeProps = PropTypes.shape({
  logo: PropTypes.node,
});



// WEBPACK FOOTER //
// ./src/themes/theme.ts